import { Trans, useTranslation } from 'react-i18next';
import ArrowRepeatIcon from 'assets/images/icons/arrow-repeat.svg?react';
import BoxArrowInRightIcon from 'assets/images/icons/box-arrow-in-right.svg?react';
import BoxArrowRightIcon from 'assets/images/icons/box-arrow-right.svg?react';
import Tooltip from 'components/tooltip/Tooltip';
import { isBeforeToday } from 'utils/dateTimeUtils';
import { CalendarDay } from '../body/CalendarBody.types';
import { DayCellIconsWrapper } from './DayCell.style';
import useDayCellIconsVisibility from './useDayCellIconsVisibility';

interface DayCellIconsProps {
  calendarDay: CalendarDay;
}

const DayCellIcons = ({ calendarDay }: DayCellIconsProps) => {
  const { t } = useTranslation();
  const time = calendarDay.date.getTime();
  const {
    isTurnoverIconVisible,
    isCheckInBlockedIconVisible,
    isCheckoutBlockedIconVisible,
  } = useDayCellIconsVisibility(calendarDay);

  if (isBeforeToday(calendarDay.date)) {
    return null;
  }

  if (isTurnoverIconVisible) {
    return (
      <DayCellIconsWrapper>
        <Tooltip
          id={`turnover-icon-${time}`}
          text={t('pageCalendar.tooltip.turnover')}
        >
          <ArrowRepeatIcon data-testid="turnover-icon" />
        </Tooltip>
      </DayCellIconsWrapper>
    );
  }

  if (calendarDay.unavailable) {
    return null;
  }

  return (
    <DayCellIconsWrapper>
      {isCheckInBlockedIconVisible && (
        <Tooltip
          id={`check-in-blocked-icon-${time}`}
          text={
            <Trans
              i18nKey="pageCalendar.tooltip.checkInNotAllowed"
              components={{ br: <br /> }}
            />
          }
        >
          <BoxArrowInRightIcon data-testid="check-in-blocked-icon" />
        </Tooltip>
      )}
      {isCheckoutBlockedIconVisible && (
        <Tooltip
          id={`checkout-blocked-icon-${time}`}
          text={
            <Trans
              i18nKey="pageCalendar.tooltip.checkoutNotAllowed"
              components={{ br: <br /> }}
            />
          }
        >
          <BoxArrowRightIcon data-testid="checkout-blocked-icon" />
        </Tooltip>
      )}
    </DayCellIconsWrapper>
  );
};

export default DayCellIcons;
